import React, { useEffect, useRef } from 'react';
import { loadGoogleMapsScript } from '../../services/GoogleMap';

const GoogleMapBranches = ({ branches }) => {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const polygonsRef = useRef([]);

  useEffect(() => {
    const initMap = async () => {
      const mapKey = localStorage.getItem('map_key') || 'AIzaSyC83oFR3cRXbLCIMZrAjJEteMT6BJOzOfo';
      
      if (!mapKey) {
        console.error('Google Maps API key is missing.');
        return;
      }

      try {
        const googleMaps = await loadGoogleMapsScript(mapKey);
        const defaultCenter = { lat: 25.276987, lng: 55.296249 };

        const map = new googleMaps.Map(mapRef.current, {
          center: defaultCenter,
          zoom: 12,
        });

        mapInstanceRef.current = map;
        drawServiceAreas(googleMaps, branches);
      } catch (error) {
        console.error('Failed to load Google Maps:', error);
      }
    };

    initMap();

    return () => {
      polygonsRef.current.forEach(polygon => polygon && polygon.setMap(null));
    };
  }, []);

  useEffect(() => {
    if (mapInstanceRef.current && window.google) {
      drawServiceAreas(window.google.maps, branches);
    }
  }, [branches]);

  const isValidCoordinate = (coord) => {
    console.log(coord);
    return (
      coord && 
      typeof coord.lat === 'number' && 
      typeof coord.lng === 'number' &&
      !isNaN(coord.lat) && 
      !isNaN(coord.lng) &&
      Math.abs(coord.lat) <= 90 &&
      Math.abs(coord.lng) <= 180
    );
  };

const drawServiceAreas = (googleMaps, branchList) => {
  // Clear existing polygons
  polygonsRef.current.forEach(polygon => polygon && polygon.setMap(null));
  polygonsRef.current = [];

  branchList.forEach(branch => {
    try {
      if (!branch.area_coordinates) {
        console.warn('Branch missing area_coordinates:', branch.id || branch.name);
        return;
      }

        // Handle multiple polygons per branch
        branch.area_coordinates.forEach((polygonCoords, polygonIndex) => {
          const validCoordinates = polygonCoords
            .map(coord => ({
              lat: parseFloat(coord.lat),
              lng: parseFloat(coord.lng)
            }))
            .filter(isValidCoordinate);

          if (validCoordinates.length >= 3) {
            const polygon = new googleMaps.Polygon({
              paths: validCoordinates,
              strokeColor: '#4285F4',
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: '#4285F4',
              fillOpacity: 0.35,
              map: mapInstanceRef.current,
            });
            polygonsRef.current.push(polygon);
          } else {
            console.warn(`Branch ${branch.id || branch.name} polygon ${polygonIndex} has insufficient valid coordinates`);
          }
        });
    } catch (error) {
      console.error('Error drawing polygon for branch:', branch.id || branch.name, error);
    }
  });

  // Auto-zoom to show all polygons
  if (polygonsRef.current.length > 0 && googleMaps) {
    try {
      const bounds = new googleMaps.LatLngBounds();
      polygonsRef.current.forEach(polygon => {
        polygon.getPaths().forEach(path => {
          path.getArray().forEach(latLng => {
            bounds.extend(latLng);
          });
        });
      });
      mapInstanceRef.current.fitBounds(bounds);
    } catch (error) {
      console.error('Error fitting bounds:', error);
    }
  }
};

  return (
    <div id="map" ref={mapRef} style={{ height: '500px', width: '100%' }} />
  );
};

export default GoogleMapBranches;